export default __webpack_public_path__ + "media/images/carousel/04-363cb4c7ceab5551cfae64c14061e22f.jpg";